module.exports = __webpack_public_path__ + "static/img/lg-watersolution-thumb.4068fc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lg-watersolution-thumb.jpg
// module id = dVon
// module chunks = 0